import {
  put,
  all,
  call,
  select,
  takeEvery,
  takeLatest,
  fork,
  cancel,
  take,
} from 'redux-saga/effects';
import {
  change, doSubmit, startSubmit, stopSubmit, reset,
} from 'circe/forms/actions';
import parsePath from 'parse-filepath';
import { generatePath } from 'react-router';
import queryString from 'qs';
import * as I18n from 'circe/I18n';
import { exception } from 'circe/logger';
import { show as showNotification } from 'circe/notifications/actions';
import PapaParse from 'papaparse';
import { FORM_NAME } from '../fuse/Forms/UploadSheet/constants';
import { ROUTES } from './view/constants';
import viewSaga from './view/saga';
import * as api from './api';
import { fetch as fetchFile } from './view/actions';
import {
  upload, setPreviewData, setPreviewDataErrors, setPreviewDataStatus,
} from './actions';
import { morphFormAddressToRequestPayload, csvFileToObjets, validateCsvData } from './utils';
import { DATA_APPROVAL_STATUS } from './constants';

function* doUpload(context, action) {
  const { payload } = action;
  const { values } = payload;

  const {
    shipperId, pickupAddress, returnAddress, sheet, pickupDate,
  } = values;

  try {
    yield put(startSubmit(FORM_NAME));
    const form = new FormData();
    form.append('file', sheet[0]);
    const reader = new FileReader();
    reader.readAsText(sheet[0], 'UTF-8');
    const parsedCSV = yield new Promise((resolve, reject) => {
      reader.onload = function (evt) {
        resolve(PapaParse.parse(evt.target.result));
      };
      reader.onerror = function (evt) {
        reject(evt);
      };
    });

    const rows = csvFileToObjets(parsedCSV.data);
    const formattedRows = csvFileToObjets(parsedCSV.data);
    yield put(setPreviewData(formattedRows));

    const headers = parsedCSV && parsedCSV.data && parsedCSV.data.length > 0 ? parsedCSV.data[0] : [];

    const errors = validateCsvData(headers, rows);
    yield put(setPreviewDataErrors(errors));

    const statusChanged = yield take(setPreviewDataStatus().type);
    const {
      payload: { status },
    } = statusChanged;

    if (
      status === DATA_APPROVAL_STATUS.REJECTED
      || (status === DATA_APPROVAL_STATUS.INITIAL && errors.length > 0)
    ) {
      yield put(stopSubmit(FORM_NAME));
      yield put(setPreviewDataErrors(errors));
      yield put(setPreviewData([]));
      yield put(setPreviewDataStatus(DATA_APPROVAL_STATUS.INITIAL));
      return;
    }

    const resp = yield call(api.upload, form);
    const { name, ext } = parsePath(resp.file);
    yield put(stopSubmit(FORM_NAME));
    const pickupAddressFormatted = morphFormAddressToRequestPayload(pickupAddress);
    const returnAddressFormatted = morphFormAddressToRequestPayload(returnAddress);
    const urlQueryString = queryString.stringify({
      pickupAddress: pickupAddressFormatted,
      returnAddress: returnAddressFormatted,
      pickupDate,
    });

    const redirectUrl = `${generatePath(ROUTES.ROOT, {
      fileName: name,
      fileExtension: ext.replace('.', ''),
      shipperId,
    })}?${urlQueryString}`;

    yield put(
      fetchFile(`${name}.${ext.replace('.', '')}`, {
        shipperId,
        pickupAddress: pickupAddressFormatted,
        returnAddress: returnAddressFormatted,
        pickupDate,
      }),
    );
  } catch (error) {
    yield put(stopSubmit(FORM_NAME));
    yield put(
      showNotification(
        I18n.str('uploadBatchSheetFailed', 'Unable to upload batch sheet.'),
        'error',
      ),
    );
    console.error(error);
    yield call(exception, error);
  }
}

export default function* (context) {
  yield all([takeEvery(upload().type, doUpload, context), viewSaga(context)]);
}
